export default __webpack_public_path__ + "static/media/168.fc422985.gif";